import React from 'react';

const IconPayment = props => {
  const { className } = props;
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <g
        fill="none"
        stroke="#115a36"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="scale(3.42857)"
      >
        <rect x={0.5} y={1.75} width={10.5} height={8} rx={1} />
        <circle cx={5.75} cy={5.75} r={1.5} />
        <path d="M3.5 12.25h9a1 1 0 001-1v-5" />
      </g>
    </svg>
  );
};

export default IconPayment;
